export default __webpack_public_path__ + "static/media/testimonialbackground.b1140114.png";